export const USER_TYPE = {
  USER: 'USER',
  SITE: 'SITE',
} as const;
